import { render, staticRenderFns } from "./SwitchBannerTypeConfirmationModal.vue?vue&type=template&id=11daf712"
import script from "./SwitchBannerTypeConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./SwitchBannerTypeConfirmationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports